<template>
  <div class="status-summary">
    <v-row
      v-for="(status, index) in statusesToDisplay"
      :key="index"
    >
      <v-col class="label">
        {{ status.label }}
      </v-col>
      <v-col class="value">
        <v-progress-linear
          :value="getStatusCountInPercentage(status.count)"
          :color="status.color"
          :height="progressBarHeight"
        >
          <template v-slot="{ value }">
            <strong>{{ value }}%</strong>
          </template>
        </v-progress-linear>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StatusColor from './../Helpers/StatusColor'

export default {
  props: {
    orders: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      progressBarHeight: 30
    }
  },

  computed: {

    /**
     * Return list of statuses that should be visible on summary
     *
     * @returns {Array}
     */
    statusesToDisplay () {
      // list of statuses, to keep fixed order for better UX
      const statuses = [
        {
          count: this.getStatusCount('NEW'),
          label: this.$t('statuses.NEW'),
          color: StatusColor.getColorByOrderStatus('NEW')
        },
        {
          count: this.getStatusCount('IN_PREPARATION'),
          label: this.$t('statuses.IN_PREPARATION'),
          color: StatusColor.getColorByOrderStatus('IN_PREPARATION')
        },
        {
          count: this.getStatusCount('PAID'),
          label: this.$t('statuses.PAID'),
          color: StatusColor.getColorByOrderStatus('PAID')
        },
        {
          count: this.getStatusCount('DELIVERED'),
          label: this.$t('statuses.DELIVERED'),
          color: StatusColor.getColorByOrderStatus('DELIVERED')
        },
        {
          count: this.getStatusCount('CANCELED'),
          label: this.$t('statuses.CANCELED'),
          color: StatusColor.getColorByOrderStatus('CANCELED')
        }
      ]

      // Show only the one with data
      return statuses.filter(status => status.count > 0)
    }
  },

  methods: {
    /**
     * Return number of orders with given status
     *
     * @param {String} status
     * @returns {Number}
     */
    getStatusCount (status) {
      return this.orders.filter(order => order.status === status).length
    },

    /**
     * Return % of orders with given status
     *
     * @returns {Number}
     */
    getStatusCountInPercentage (count) {
      const result = (count * 100/ this.orders.length).toFixed(1)

      return result
    }
  }
}
</script>


<style lang="scss" scoped>
.status-summary {
  float: left;

  .col {
    padding: 6px;
  }

  .label {
    text-align: right;
    width: 180px;
  }

  .value {
    width: 220px;
  }
}
</style>
